(() => {
  async function refreshAvailability(panel) {
    const details = panel.closest('.ccsg-quickshop');
    const buttons = [...panel.querySelectorAll('.ccsg-quickshop__size')];
    buttons.forEach(button => { button.disabled = true; });
    panel.setAttribute('aria-busy', 'true');

    try {
      const productUrl = details?.dataset.productUrl;
      if (productUrl) {
        const response = await fetch(productUrl + '.js', { cache: 'no-store', credentials: 'same-origin' });
        if (response.ok) {
          const product = await response.json();
          if (Array.isArray(product.variants)) {
            panel.dataset.availabilitySource = 'live';
            const available = new Set(product.variants.filter(variant => variant.available).map(variant => String(variant.id)));
            buttons.forEach(button => {
              if (!available.has(button.dataset.variantId)) button.remove();
            });
            const id = panel.querySelector('[name="id"]');
            const add = panel.querySelector('.ccsg-quickshop__add');
            if (id?.value && !available.has(id.value)) {
              id.value = '';
              if (add) add.disabled = true;
            }
          }
        }
      }
    } catch (_) {
      panel.dataset.availabilitySource = 'rendered';
      // Keep the server-rendered availability when the product feed cannot be reached.
    } finally {
      panel.querySelectorAll('.ccsg-quickshop__size').forEach(button => { button.disabled = false; });
      panel.removeAttribute('aria-busy');
    }

    const sizes = panel.querySelector('.ccsg-quickshop__sizes');
    const add = panel.querySelector('.ccsg-quickshop__add');
    if (sizes && !sizes.querySelector('.ccsg-quickshop__size')) {
      sizes.hidden = true;
      panel.querySelector('.ccsg-quickshop__title').textContent = 'Currently sold out';
      if (add) add.disabled = true;
    }
    if (!sizes && !panel.querySelector('[name="id"]')?.value) {
      panel.querySelector('.ccsg-quickshop__title').textContent = 'Currently sold out';
      if (add) add.disabled = true;
    }
  }

  function filter(panel, width) {
    panel.querySelectorAll('[data-variant-id]').forEach(button => {
      button.hidden = Boolean(width) && button.dataset.width !== width;
      button.setAttribute('aria-pressed', 'false');
    });
    panel.querySelectorAll('.ccsg-quickshop__width').forEach(button =>
      button.setAttribute('aria-pressed', String(button.dataset.width === width))
    );
    const id = panel.querySelector('[name="id"]');
    const add = panel.querySelector('[type="submit"]');
    if (id && add && panel.querySelectorAll('[data-variant-id]').length) {
      id.value = '';
      add.disabled = true;
    }
  }

  function init(panel) {
    if (panel.dataset.ready) return;
    panel.dataset.ready = '1';
    const items = [...panel.querySelectorAll('[data-variant-id]')];
    const tabs = panel.querySelector('.ccsg-quickshop__widths');
    const widths = [...new Set(items.map(item => item.dataset.width).filter(Boolean))];
    if (widths.length > 1) {
      tabs.hidden = false;
      widths.forEach((width, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ccsg-quickshop__width';
        button.textContent = width;
        button.dataset.width = width;
        button.setAttribute('aria-pressed', String(index === 0));
        tabs.append(button);
      });
      filter(panel, widths[0]);
    } else if (widths.length === 1) {
      filter(panel, widths[0]);
    }
  }

  document.addEventListener('click', event => {
    const link = event.target.closest?.('a');
    const card = link?.closest('.product-card-wrapper');
    const details = card?.querySelector('.ccsg-quickshop');
    const summary = details?.querySelector('summary');
    if (!summary) return;
    const rect = summary.getBoundingClientRect();
    if (event.clientX >= rect.left && event.clientX <= rect.right &&
        event.clientY >= rect.top && event.clientY <= rect.bottom) {
      event.preventDefault();
      event.stopImmediatePropagation();
      details.open = !details.open;
    }
  }, true);

  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!details.matches?.('.ccsg-quickshop') || !details.open) return;
    document.querySelectorAll('.ccsg-quickshop[open]').forEach(other => {
      if (other !== details) other.open = false;
    });
    const panel = details.querySelector('.ccsg-quickshop__panel');
    const ready = panel.dataset.ready;
    Promise.resolve(ready ? null : refreshAvailability(panel)).then(() => {
      if (!details.open) return;
      init(panel);
      requestAnimationFrame(() => {
        const edges = [...document.querySelectorAll('.section-header,#main-collection-filters')]
          .map(element => element.getBoundingClientRect())
          .filter(rect => rect.height > 0 && rect.top < innerHeight / 2)
          .map(rect => rect.bottom);
        const covered = Math.max(0, ...edges);
        const top = panel.getBoundingClientRect().top;
        if (top < covered + 12) window.scrollBy({ top: top - covered - 12, behavior: 'smooth' });
      });
    });
  }, true);

  document.addEventListener('click', event => {
    const width = event.target.closest('.ccsg-quickshop__width');
    if (width) {
      filter(width.closest('.ccsg-quickshop__panel'), width.dataset.width);
      return;
    }
    const size = event.target.closest('.ccsg-quickshop__size');
    if (size) {
      const panel = size.closest('.ccsg-quickshop__panel');
      if (!panel || size.disabled) return;
      panel.querySelectorAll('[data-variant-id]').forEach(button =>
        button.setAttribute('aria-pressed', String(button === size))
      );
      panel.querySelector('[name="id"]').value = size.dataset.variantId;
      panel.querySelector('[type="submit"]').disabled = false;
      return;
    }
    if (!event.target.closest('.ccsg-quickshop'))
      document.querySelectorAll('.ccsg-quickshop[open]').forEach(details => { details.open = false; });
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape')
      document.querySelectorAll('.ccsg-quickshop[open]').forEach(details => { details.open = false; });
  });
})();
